import { useEffect, useState } from "react";
import { FilePdf, Trash } from "@phosphor-icons/react";
import { api } from "../lib/api";

export const DocThumbnail = ({ customerId, doc, label, onOpen, canDelete, onDelete }) => {
  const [url, setUrl] = useState(null);
  const isImage = (doc.content_type || "").startsWith("image/");

  useEffect(() => {
    let objUrl;
    if (isImage) {
      api.get(`/customers/${customerId}/documents/${doc.id}/download`, { responseType: "blob" })
        .then((r) => { objUrl = URL.createObjectURL(r.data); setUrl(objUrl); })
        .catch(() => {});
    }
    return () => { if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [customerId, doc.id, isImage]);

  return (
    <div className="relative border border-border rounded-md overflow-hidden bg-muted hover:border-primary transition-colors">
      {canDelete && (
        <button type="button" data-testid={`doc-delete-${doc.doc_type}`}
          onClick={(e) => { e.stopPropagation(); onDelete(); }}
          className="absolute top-1 right-1 z-10 bg-red-500 hover:bg-red-600 text-white rounded-full p-1.5 shadow-md active:scale-90 transition-transform">
          <Trash size={12} weight="bold" />
        </button>
      )}
      <button type="button" data-testid={`doc-thumb-${doc.doc_type}`} onClick={onOpen} className="w-full text-left active:scale-95 transition-transform">
        <div className="aspect-square flex items-center justify-center overflow-hidden bg-white">
          {isImage ? (
            url ? <img src={url} alt={label} className="w-full h-full object-cover" />
              : <div className="text-[10px] text-muted-foreground font-mono">Loading...</div>
          ) : (
            <FilePdf size={36} className="text-red-500" />
          )}
        </div>
        <div className="p-1.5">
          <div className="text-[10px] font-semibold leading-tight truncate">{label}</div>
          <div className="text-[9px] text-muted-foreground truncate">{doc.uploaded_by}</div>
        </div>
      </button>
    </div>
  );
};
